// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { PharmacyGroupActions, PharmacyGroupActionTypes } from '../_actions/pharmacy-group.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PharmacyGroup } from '../_models/pharmacy-group.model';

// tslint:disable-next-line:no-empty-interface
export interface PharmacyGroupsState extends EntityState<PharmacyGroup> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPharmacyGroupId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<PharmacyGroup> = createEntityAdapter<PharmacyGroup>();

export const initialPharmacyGroupsState: PharmacyGroupsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedPharmacyGroupId: undefined,
  showInitWaitingMessage: true,
});

export function pharmacyGroupsReducer(
  state = initialPharmacyGroupsState,
  action: PharmacyGroupActions,
): PharmacyGroupsState {
  switch (action.type) {
    case PharmacyGroupActionTypes.PharmacyGroupsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPharmacyGroupId: undefined,
      };
    case PharmacyGroupActionTypes.PharmacyGroupsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case PharmacyGroupActionTypes.PharmacyGroupCreated:
      return adapter.addOne(action.payload.pharmacyGroup, {
        ...state,
        lastCreatedPharmacyGroupId: action.payload.pharmacyGroup.id,
      });
    case PharmacyGroupActionTypes.PharmacyGroupUpdated:
      return adapter.updateOne(action.payload.partialPharmacyGroup, state);
    case PharmacyGroupActionTypes.PharmacyGroupDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PharmacyGroupActionTypes.PharmacyGroupsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case PharmacyGroupActionTypes.PharmacyGroupsPageLoaded: {
      return adapter.addMany(action.payload.pharmacyGroups, {
        ...initialPharmacyGroupsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case PharmacyGroupActionTypes.ThrowPharmacyGroupError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PharmacyGroupActionTypes.FirePharmacyGroupSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getPharmacyGroupState = createFeatureSelector<PharmacyGroupsState>('pharmacyGroups');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
